import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import LookupPage from './pages/LookupPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeAuth, setStoredToken, removeStoredToken, isAdmin } from './utils/auth';

function App() {
  const [token, setToken] = useState(initializeAuth());

  const handleLogin = (newToken) => {
    setToken(newToken);
    setStoredToken(newToken);
  };

  const handleLogout = () => {
    setToken(null);
    removeStoredToken();
  };

  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
          <Route
            path="/lookup"
            element={
              token ? (
                <LookupPage token={token} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/profile"
            element={
              token ? (
                <ProfilePage token={token} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/admin"
            element={
              token && isAdmin(token) ? (
                <AdminPage token={token} onLogout={handleLogout} />
              ) : (
                <Navigate to={token ? "/lookup" : "/login"} />
              )
            }
          />
          <Route path="*" element={<Navigate to={token ? "/lookup" : "/login"} />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App; 